
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiSelect, UiTextbox } from '../keen-ui'
import InputErrors from '../shared/input-errors.component.vue'
import InputLabel from '../shared/input-label.component.vue'

export default defineComponent({
  name: 'StringServiceConfigField',
  components: {
    UiSelect,
    InputLabel,
    InputErrors,
    UiTextbox,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    options: {
      type: Array as PropType<Array<string>>,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    rows: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      baseClass: 'epb-string-service-config-field',
      dirty: false,
    }
  },
})
